import React from "react";
import { Button, Container, Row } from "reactstrap";
import RecentlyViewed from "../Cart/RecentlyViewed";
import tshirt from "../../../assets/images/dummyImages/t-shirt-1.jpg";
import BackButton from "../../../components/common/BackButton/BackButton";
import styles from "./OrderPlaced.module.scss";
import { GoCheckCircleFill } from "react-icons/go";
import { useNavigate } from "react-router-dom";

const OrderPlaced = () => {
  const navigate = useNavigate();

  const orderedProducts = [
    { img: "https://placehold.co/136x126?text=Maelano", title: "Purple Sports Shirt", price: 33.99 },
    { img: "https://placehold.co/136x126?text=Maelano", title: "Purple Sports Shirt", price: 33.99 },
  ]
  const products = [
    {
      id: 1,
      name: "Name of product will be here",
      price: 33.99,
      originalPrice: 49.99,
      rating: 5.0,
      reviews: 300,
      image: tshirt,
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
    },
    {
      id: 2,
      name: "Another product name",
      price: 29.99,
      originalPrice: 39.99,
      rating: 4.5,
      reviews: 250,
      image: tshirt,
      description:
        "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.",
    },
    {
      id: 3,
      name: "Stylish T-shirt",
      price: 19.99,
      originalPrice: 24.99,
      rating: 4.2,
      reviews: 180,
      image: tshirt,
      description:
        "A stylish t-shirt that fits perfectly for all occasions, available in multiple colors.",
    },
    {
      id: 4,
      name: "Cool Hoodie",
      price: 49.99,
      originalPrice: 59.99,
      rating: 4.7,
      reviews: 120,
      image: tshirt,
      description:
        "Stay warm and stylish with this cool hoodie, made from high-quality fabric.",
    },
    {
      id: 5,
      name: "Casual Sneakers",
      price: 59.99,
      originalPrice: 79.99,
      rating: 4.9,
      reviews: 400,
      image: tshirt,
      description:
        "Comfortable and trendy sneakers, perfect for everyday use and sports activities.",
    },
    {
      id: 6,
      name: "Name of product will be here",
      price: 33.99,
      originalPrice: 49.99,
      rating: 5.0,
      reviews: 300,
      image: tshirt,
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
    },
    {
      id: 7,
      name: "Another product name",
      price: 29.99,
      originalPrice: 39.99,
      rating: 4.5,
      reviews: 250,
      image: tshirt,
      description:
        "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.",
    },
    {
      id: 8,
      name: "Stylish T-shirt",
      price: 19.99,
      originalPrice: 24.99,
      rating: 4.2,
      reviews: 180,
      image: tshirt,
      description:
        "A stylish t-shirt that fits perfectly for all occasions, available in multiple colors.",
    },
  ];

  return (
    <>
      <BackButton />
      <div className={styles.mainOrderPlacedContainer}>

        <div className={styles.orderConfirmWrapper}>
          <div>
            <GoCheckCircleFill size={180} color="#FBBD34" />
          </div>
          <div>
            <h4>Order ID: 68409258</h4>
            <p className={styles.orderPlacedText}>Your order has been placed</p>
          </div>
          <div className={styles.btnConatiner}>
            <Button
              color="link"
              className={styles.receiptBtn}
              onClick={() => navigate("/checkout/order-placed/e-receipt")}
            >
              E-Receipt
            </Button>
            <Button color="link" className={styles.shoppingBtn}>Continue Shopping</Button>
          </div>
        </div>

        <Container fluid className={styles.orderedProductContainer}>
          <h3 className={styles.sectionHeading}>Ordered Products</h3>
          <Row className={styles.orderedProductRow}>
            {orderedProducts.map((product, index) => (
              <div key={index} className={styles.orderedProductColumn}>
                <div className={styles.productDetailWrapper}>
                  <div className={styles.imgContainer}>
                    <img src={product.img} alt="Maelano Img" />
                  </div>
                  <p className={styles.productTitle}>{product.title}</p>
                </div>
                <div>
                  <p className={styles.productPrice}>${product.price}</p>
                </div>
              </div>
            ))}
          </Row>
        </Container>

        <h3 className={styles.sectionHeading}>Recently Viewed</h3>
        <div className={styles.reviewedSection}>
          <RecentlyViewed products={products.slice(0, 6)} />
        </div>
      </div>
    </>
  );
};

export default OrderPlaced;
